import type { Income } from '@/types/AddIncome'

export type Action = {
  field: string
  payload: any
}

const set = (object: any, path: string, value: any) => {
  const fields = path.split('.')

  let obj = object
  for (let i = 0; i < fields.length - 1; i++) {
    obj = obj[fields[i]]
  }

  obj[fields[fields.length - 1]] = value
}

export function incomeReducer(income: Income, action: Action): Income {
  const { field, payload } = action

  set(income, field, payload)
  return {
    ...income,
  }
}
